function generateTestId(sectionId: string, selectorType: string, parts: string[], endsWithSeparator = false): string {
    const separator = '__';
    const id = [sectionId, selectorType, ...parts].join(separator);

    return endsWithSeparator ? id + separator : id;
}

const SECTION_IDS = {
    newsletter: 'newsletter',
    productTile: 'productTile',
    carousel: 'carousel',
    reinsurance: 'reinsurance',
    service: 'service',
    homeSlot: 'homeSlot',
};

const SELECTOR_TYPES = {
    button: 'btn',
    section: 'sec',
    link: 'link',
    text: 'txt',
    input: 'in',
    badge: 'badge',
};

const STATIC_TEST_IDS: Record<string, string> = {
    accountUserConnectionButton: 'account-user-connection-button',
    addToBasketButton: 'add-to-basket-button',
    addToBasketFixed: 'add-to-basket-fixed',
    backToHomepageLink: 'back-to-homepage-link',
    backToTopButton: 'back-to-top-button',
    closeSearchPanelButton: 'close-search-panel-button',
    connectionBannerLoginButton: 'connection-banner-login-button',
    headerWishlistLink: 'header-wishlist-link',
    notifyMeMailInput: 'notify-me-mail-input',
    notifyMeButton: 'notify-me-button',
    notifyMeConfirmMessage: 'notify-me-subscription-confirm-message',
    newsletterModal: 'newsletter-modal',
    newsletterSubscriptionConfirmButton: 'newsletter-subscription-confirm-button',
    newsletterSubscriptionConfirmMessage: 'newsletter-subscription-confirm-message',
    newsletterSubscriptionEditButton: 'newsletter-subscription-edit-button',
    recentSearchesClearButton: 'recent-searches-clear-button',
    recentSearchesContainer: 'recent-searches-container',
    recentSearchesTitle: 'recent-searches-title',
    searchBar: 'search-bar',
    searchProductsBanner: 'search-products-banner',
    searchShowAllProductsButton: 'search-show-all-products-button',
    wishlistButton: 'wishlist-button',
    wishlistLoginModal: 'wishlist-login-modal',
    wishlistLoginModalConnectionButton: 'wishlist-login-modal-connection-button',
    wishlistProductNumberIcon: 'wishlist-product-number-icon',
};

const GENERATED_TEST_IDS: Record<string, string> = {
    newsletterSubscriptionButton: generateTestId(SECTION_IDS.newsletter, SELECTOR_TYPES.button, ['submit']),
    newsletterSection: generateTestId(SECTION_IDS.homeSlot, SELECTOR_TYPES.section, ['newsletter']),
    newsletterMailInput: generateTestId(SECTION_IDS.newsletter, SELECTOR_TYPES.input, ['email']),
    openBarServicesSection: generateTestId(SECTION_IDS.service, SELECTOR_TYPES.section, [], true),
    reinsuranceSection: generateTestId(SECTION_IDS.reinsurance, SELECTOR_TYPES.section, [], true),
    reinsuranceSectionLink: generateTestId(SECTION_IDS.reinsurance, SELECTOR_TYPES.link, [], true),
    carouselPrevButton: generateTestId(SECTION_IDS.carousel, SELECTOR_TYPES.button, ['prev']),
    carouselNextButton: generateTestId(SECTION_IDS.carousel, SELECTOR_TYPES.button, ['next']),
    productTileBadge: generateTestId(SECTION_IDS.productTile, SELECTOR_TYPES.badge, []),
    productTileTitle: generateTestId(SECTION_IDS.productTile, SELECTOR_TYPES.text, ['title']),
    productTilePrice: generateTestId(SECTION_IDS.productTile, SELECTOR_TYPES.text, ['price']),
    productTileRating: generateTestId(SECTION_IDS.productTile, SELECTOR_TYPES.text, ['rating']),
    productTilewishlistButton: generateTestId(SECTION_IDS.productTile, SELECTOR_TYPES.button, ['wishlist']),
    productTileDiscoverButton: generateTestId(SECTION_IDS.productTile, SELECTOR_TYPES.button, ['discover']),
    homeSlotSection: generateTestId(SECTION_IDS.homeSlot, SELECTOR_TYPES.section, [], true),
};

export const DataTestConfig = {
    testIds: {
        ...STATIC_TEST_IDS,
        ...GENERATED_TEST_IDS,
    },
};
